// extracted by mini-css-extract-plugin
export default {"surveyResultSection":"surveyResultSection-FFRxAl","surveyResultSection__header":"surveyResultSection__header-Mu8JUc"};